import PropTypes from "prop-types";
import useJobProgress from "hooks/useJobProgress";
import ProgressLoader from "components/shared/progress-loader/ProgressLoader";
import LinearProgressLoader from "components/shared/progress-loader/LinearProgressLoader";
import { useEffect, useState } from "react";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import { JobProgressStatus } from "constants/JobProgress";
import { MAX_DOWNLOAD_REQUESTS } from "constants/MaxDownloadRequests";
let counter = 0;
const JobProgressLoader = ({ requestId, onFinish, size, isLinear = false }) => {
    const limitNumberRequests = () => {
        counter++;
        if (counter > MAX_DOWNLOAD_REQUESTS) {
            setStopRequest(true);
            counter = 0;
        }
    };
    const [progress, setProgress] = useState(0);
    const [stopRequest, setStopRequest] = useState(false);
    const { data, isError, isFinished } = useJobProgress(
        requestId,
        limitNumberRequests,
        stopRequest
    );

    useEffect(() => {
        if (isFinished) {
            onFinish(
                isError ? JobProgressStatus.Failed : JobProgressStatus.Finished
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFinished]);

    useEffect(() => {
        if (data?.progress) {
            setProgress(Math.floor(data.progress * 100));
        }
    }, [data?.progress]);

    return (
        <>
            {isError ? (
                <ErrorIcon color="primary" />
            ) : isLinear ? (
                <LinearProgressLoader value={progress} />
            ) : (
                <ProgressLoader value={progress} size={size} />
            )}
        </>
    );
};

JobProgressLoader.propTypes = {
    requestId: PropTypes.string.isRequired,
    size: PropTypes.number,
    onFinish: PropTypes.func,
    isLinear: PropTypes.bool,
};

export default JobProgressLoader;
